/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback,  useEffect, useState } from "react";
import {
  Button,
  Col,
  Divider,
  Input,
  // DatePicker,
  Row,
  // Select,
} from "antd";
import { SearchOutlined, DownloadOutlined } from "@ant-design/icons";
// import moment from "moment";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import * as XLSX from "xlsx";
// import { APIrequest } from "../../../model/client/request";
import { State } from "../../../model/application/state";
import SearchDatatable from "../../../shared/component/searchDatatable";
import { AuditLog } from "../../../service/action/merchant";
import { MerchantLayoutContainer } from "../../../shared/layout/MerchantLayoutContainer";
import { DataTableUtil } from "../../../shared/component/data-table-util";
import { DataTable } from "../../../shared/component/data-table";

// const { RangePicker } = DatePicker;

export const AuditLogs = () => {
  const dispatch = useDispatch();
  const [column, setColumn] = useState([] as any);
  const { auditLog }: any = useSelector((state) => state);
  const state: State.MerchantAuditLogs = auditLog;
  const GetAuditLogs = useCallback(
    (state: State.MerchantAuditLogs) => {
      dispatch({
        type: AuditLog.Get_Audit_Logs,
        payload: {
          ...state,
        },
      });
    },
    [state]
  );

  const Search = useCallback(
    async (value: string, state: State.MerchantAuditLogs) => {
      const response = await SearchDatatable.Search(
        state.originalResponse,
        value
      );
      dispatch({
        type: AuditLog.Set_Audit_Logs,
        payload: {
          ...state,
          response,
        },
      });
    },
    [state]
  );
  const setColumns = async () => {
    let columns = column;
    columns = [
      "key",
      "Action Name_10%",
      "Action_10%",
      "Performed By_10%",
      "Merchant Id_8%",
      "Date_15%",
    ];
    columns = DataTableUtil.SetColumn(columns);
    await setColumn(columns);
  };

   useEffect(() => {
    GetAuditLogs(state);
    setColumns();
  }, []);
  // const dateFormat = "YYYY-MM-DD";

  // const setDate = (date: any, dateString: any) => {
  //     dispatch({
  //         type: AuditLog.Set_Audit_Logs,
  //         payload: {
  //             ...state,
  //             processing: false,
  //             filterRequests: {
  //                 ...state.filterRequests,
  //                 fromDate: dateString[0],
  //                 toDate: dateString[1],
  //                 size: 100,
  //                 page: 0,
  //             },
  //         }
  //     })
  // }

  // const FilterAudit = useCallback(
  //     (state: State.MerchantAuditLogs) => {
  //         dispatch({
  //             type: AuditLog.Filter_Audit_Logs,
  //             payload: {
  //                 ...state,
  //                 isDownload: false,
  //                 processing: true
  //             }
  //         })
  //     },
  //     [state],
  // )

  // const setRequest = useCallback(
  //     (state: State.MerchantAuditLogs, value: any, key: keyof APIrequest.AuditLogSearch) => {
  //         dispatch({
  //             type: AuditLog.Set_Audit_Logs,
  //             payload: {
  //                 ...state,
  //                 filterRequests: {
  //                     ...state.filterRequests,
  //                     [key]: value,
  //                     size: 100,
  //                     page: 0
  //                 }
  //             }
  //         })
  //     },
  //     [state],
  // )

  const handleDownloadReport = () => {
    let wb = XLSX?.utils?.book_new(),
      ws = XLSX?.utils?.json_to_sheet(state.response);

    XLSX?.utils?.book_append_sheet(wb, ws, "MySheet1");

    XLSX?.writeFile(wb, "XBS-Audit-Logs.xlsx");
  };
  // const ClearAudit = useCallback(
  //     (state: State.MerchantAuditLogs) => {
  //         dispatch({
  //             type: AuditLog.Set_Audit_Logs,
  //             payload: {
  //                 ...state,
  //                 filterRequests: new APIrequest.AuditLogSearch(),
  //             }
  //         })
  //     },
  //     [state],
  // )

  // const Actions = [
  //     "CREATE_USER", "UPDATE_USER", "DISABLE_USER", "ENABLE_USER",
  //     "CREATE_ROLE", "UPDATE_ROLE", "DELETE_ROLE",
  //     "RESET_API_KEYS",
  //     "CREATE_KYC", "UPDATE_KYC", "DELETE_KYC_IMAGE",
  //     "USER_LOGIN", "USER_LOGOUT",

  // ]

  return (
    <MerchantLayoutContainer defaultSelectedKeys="11" pageTitle="Audit Logs">
      <Row justify="space-between" style={{ width: "100%", marginTop: 20 }}>
        {/* <Col  style={{ width: "fit-content",display: 'flex',gap: 10 }}>
                    <RangePicker
                        style={{ marginBottom: 10, width: "200px" }}

                        format={dateFormat}
                        onChange={setDate}
                        ranges={{
                            Today: [moment(), moment()],
                            "This month": [
                                moment().startOf("month"),
                                moment().endOf("month")
                            ]
                        }}
                    />
                    <Input style={{width: '20rem',height: 40}}
                        placeholder="Performed By"
                        value={state.filterRequests?.performedBy}
                        onChange={(e) => setRequest(state, e.target.value, "performedBy")} />

<Input style={{width: '20rem',height: 40}}
                        placeholder="Action Name"
                        value={state.filterRequests?.actionName}
                        onChange={(e) => setRequest(state, e.target.value, "actionName")} />

                    <Select placeholder="Actions" value={state.filterRequests?.action}
                        onChange={(e) => setRequest(state, e, "action")} style={{ width: '10rem' }}>
                        {Actions.map(item =>
                            <Select.Option value={item}>{item}</Select.Option>
                        )}
                    </Select>

                    <Button type="default" onClick={() => ClearAudit(state)} style={{ width: 100, marginLeft: 10, color: '#2B872B',borderColor: '#2B872B' }}>Clear</Button>
                    <Button type="primary" onClick={() => FilterAudit(state)} style={{ width: 100, marginLeft: 10 }}>Filter</Button>
        </Col> */}
        <Col
          span={24}
          style={{ display: "flex", justifyContent: "space-between" }}
          data-aos="zoom-in-up"
        >
          <Button
            style={{
              marginLeft: 20,
              fontSize: 12,
            }}
            type="primary"
            icon={<DownloadOutlined rev={undefined} />}
            onClick={handleDownloadReport}
            className='rounded-3xl flex items-center justify-center'
          >
            Download
          </Button>

          <Input
            style={{
              width: 300,
              border: "1px solid grey",
              height: 35,
              marginLeft: 20,
              float: "right",
            }}
            onChange={(e) => Search(e.target.value, state)}
            typeof="text"
            prefix={<SearchOutlined style={{ color: "grey" }} rev={undefined} />}
            placeholder="Search Audit Logs"
            className="rounded-3xl"
          />
        </Col>
      </Row>

      <Divider />
      <DataTable rows={state.response as any} pageSize={20} columns={column} />
    </MerchantLayoutContainer>
  );
};
